<template>
  <div>
    <footer class="main-footer">
      <section class="container">
        <div class="row justify-content-between">
          <div class="col-lg-6">
            <a href="www.glpi.com.br">www.glpi.com.br</a>
            <p>
              Av. Brigadeiro Faria Lima, 1485 | 11º andar <br />
              CEP 01452-002 São Paulo - SP <br />
              Tel +55 11 2149-4500
            </p>
          </div>
          <div class="col-lg-3">
            <h3>ACOMPANHE</h3>
            <ul class="row">
              <li class="col-lg-3 p-0 col-md-1 col-2">
                <a
                  href="https://www.facebook.com/gusmaoelabrunie?fref=ts"
                  target="_blank"
                  ><img
                    src="@/views/home/assets/images/facebook-circular-logo.svg"
                    alt=""
                /></a>
              </li>
              <li class="col-lg-3 p-0 col-md-1 col-2">
                <a
                  href="https://www.instagram.com/gusmaoelabrunie/"
                  target="_blank"
                  ><img src="@/views/home/assets/images/instagram.svg" alt=""
                /></a>
              </li>
              <li class="col-lg-3 p-0 col-md-1 col-2">
                <a
                  href="https://www.linkedin.com/company/gusmao-&-labrunie/"
                  target="_blank"
                  ><img src="@/views/home/assets/images/linkedin.svg" alt=""
                /></a>
              </li>
              <!-- <li class="col-lg-3 p-0 col-md-1 col-2">
                <a href=""
                  ><img src="@/views/home/assets/images/youtube.svg" alt=""
                /></a>
              </li> -->
            </ul>
          </div>
        </div>
        <span>
          POWERED BY
          <a href="https://www.99jobs.com/" target="_blank">99JOBS</a>
        </span>
      </section>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",

  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },

  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
.main-footer {
  background-color: #474b4f;
  padding: 5rem 0px 2rem 0px;
  margin-top: 12rem;
  .container {
    position: relative;
    min-height: 280px;
  }
  span {
    color: #fff;
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: 4rem;
    font-size: 0.8rem;
    a {
      font-size: 0.8rem;
    }
  }
  a {
    color: #fff;
    font-weight: bold;
    font-size: 1.4rem;
  }
  h3,
  p {
    color: #fff;
  }
  p {
    font-size: 1.2rem;
  }
  h3 {
    margin: 0px 0px 1.7rem 1.3rem;
    font-size: 1.5rem !important;
  }
  ul {
    padding: 0px;
    margin: 0px;
    li {
      img {
        width: 35px;
      }
    }
  }
  @include media-breakpoint-down(md) {
    margin-top: 3rem;
    h3 {
      margin-left: 0px;
    }
    p {
      margin: 1rem 0px 3rem 0px;
    }
    ul {
      margin-bottom: 5rem;
    }
    span {
      margin: 0 auto !important;
      display: block;
      left: 0;
      right: 0;
      text-align: center;
    }
  }
}
</style>